import { buildProviderModule } from 'inversify-binding-decorators';
const context = require.context('@/services', true, /\.ts/);
context.keys().forEach((key) => {
    if (!key.endsWith('test.ts')) {
        context(key);
    }
});
export const services = buildProviderModule();
